import React from 'react';
import './footer.css';

// Icons
import iconPP from '../Img/graduation-cap.svg';

const socialLinks = [
    {
      href: "https://www.linkedin.com/in/judericketts/",
      icon: "https://www.svgrepo.com/show/517550/linkedin.svg",
      alt: "LinkedIn"
    },   
    {
      href: "https://www.instagram.com/lovespictures__/",
      icon: "https://www.svgrepo.com/show/517070/instagram.svg",
      alt: "Instagram"
    },
     {
      href: "https://research.brighton.ac.uk/en/persons/judith-ricketts",
      icon: iconPP,
      alt: "Pure Research Profile"   
    },
  ];
  
  export const SocialIcons = () => (
    <div className="social-icons">
      {socialLinks.map((link) => (
        <a
          key={link.href}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon"
        >
          <img src={link.icon} alt={link.alt} width="24" height="24" />
        </a>
      ))}
    </div>
  );

  export const Footer = () => {
    const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <SocialIcons />
        <p className="copyright">
          © Jude Ricketts {currentYear}
        </p>
      </div>
    </footer>
);
};